











import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  name: "AppButton",
})
export default class AppButton extends Vue {
  @Prop({
    type: String,
    default: "",
  })
  private text!: string;

  @Prop({
    type: String,
    default: "",
  })
  private icon!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  private disabled!: boolean;

  onClick(e: PointerEvent) {
    this.$emit("click", e);
  }
}
